import { axiosApiClient } from "..";

const paymentService = {
  /**
   * Initiate payment - creates order and gets payment form data
   */
  initiatePayment: async (orderData) => {
    try {
      const response = await axiosApiClient.post(
        "/payment/initiate",
        orderData,
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Greška prilikom iniciranja plaćanja",
        }
      );
    }
  },

  /**
   * Check payment/order status
   */
  checkPaymentStatus: async (orderNumber) => {
    try {
      const response = await axiosApiClient.get(
        `/payment/status/${orderNumber}`,
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Greška prilikom provere statusa",
        }
      );
    }
  },
};

export default paymentService;
